import { DialogActionsProps as MUIDialogActionsProps } from '@mui/material'

export type DialogActionsProps = MUIDialogActionsProps
